let loadPromise: Promise<void> | null = null;

/** Load vendored liquid-glass-js Container class (requires window.html2canvas). */
export function loadLiquidGlass(): Promise<void> {
  if (typeof window.Container !== "undefined") {
    return Promise.resolve();
  }

  if (!loadPromise) {
    loadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const base = process.env.PUBLIC_URL || "";
      script.src = `${base}/vendor/liquid-glass/container.js`;
      script.async = true;
      script.onload = () => {
        if (typeof window.Container === "undefined") {
          reject(new Error("liquid-glass container.js did not define Container"));
          return;
        }
        resolve();
      };
      script.onerror = () =>
        reject(new Error("Failed to load liquid-glass container.js"));
      document.body.appendChild(script);
    });
  }

  return loadPromise;
}

/** Re-measure and redraw all glass instances (e.g. after list layout changes). */
export function refreshAllLiquidGlass(): void {
  if (typeof window.Container === "undefined") return;
  requestAnimationFrame(() => {
    window.Container.instances.forEach((instance) => {
      instance.updateSizeFromDOM();
      instance.render?.();
    });
  });
}
